import Link from 'components/shared/Link/Link';
import { SubnavProps } from 'libs/contentful/props';
import { Colorways } from 'types/constants';
import { getSectionProps } from 'utils/styles';

export const Subnav = ({ linksCollection, sectionName }: SubnavProps) => {
  const links = linksCollection.items;
  const color = Colorways.Inverse;

  return (
    <section {...getSectionProps(color, undefined, sectionName)}>
      <nav
        className={`flex sm:justify-center gap-8 md:gap-16 py-6 font-serif overflow-x-auto no-scrollbar text-nowrap text-body-serif leading-[1.225rem]`}>
        {links.map(item => {
          return (
            <Link
              key={`subnav-${item.text}-link`}
              href={item.url}
              isSubnav={true}
              className="first:pl-6 sm:first:pl-10 last:pr-6 sm:last:pr-10 hover:text-fern focus:text-fern">
              {item.text} ›
            </Link>
          );
        })}
      </nav>
    </section>
  );
};

export default Subnav;
